var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "summary-info" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.summary[0].label) + " (G):"),
          ]),
          _c("span", { staticClass: "data" }, [
            _vm._v(_vm._s(_vm.summary[0].value)),
          ]),
        ]),
        _c("div", [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.summary[1].label) + " (I):"),
          ]),
          _c("span", { staticClass: "data" }, [
            _vm._v(_vm._s(_vm.summary[1].value)),
          ]),
        ]),
        _c(_setup.LfGrayCounterComponent, {
          attrs: { info: _setup.rentabilityCounter },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_setup.parseCounters.slice(-6, -3), function (counter, index) {
        return _c(_setup.LfGrayCounterComponent, {
          key: index,
          attrs: { info: counter },
        })
      }),
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_setup.parseCounters.slice(-3), function (counter, index) {
        return _c(_setup.LfGrayCounterComponent, {
          key: index,
          attrs: { info: counter },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }